// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__v99UB","widget":"styles_widget__qOoz9","badge":"styles_badge__IFoOi"};